import Vue, { PropType } from "vue";
import ProjectHeader from "./index.vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";
import { BadRequestError } from "@/api/types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  props: {
    graduateYear: {
      type: Number as PropType<ContainerProps["graduateYear"]>,
      default: 0
    },
    planName: {
      type: String as PropType<ContainerProps["planName"]>,
      required: true
    },
    planPeriod: {
      type: String as PropType<ContainerProps["planPeriod"]>,
      required: true
    }
  },
  computed: {
    partnerUser() {
      return this.$store.state.domains.user.partnerUser;
    },
    planId() {
      return Number(this.$route.params["planId"]);
    },
    applicationPlan() {
      return this.$store.state.pages.plan.applicationPlan;
    },
    currentPlan() {
      return this.$store.state.domains.plan.currentPlan;
    }
  },
  methods: {
    async updatePlan(name) {
      if (!this.partnerUser) {
        return;
      }
      try {
        await this.$store.dispatch("domains/plan/updatePlan", {
          partnerId: this.partnerUser.partner.id,
          planId: this.planId,
          name
        });
        this.$emit("updatePage");
      } catch (error) {
        if (error instanceof BadRequestError) {
          this.$store.commit("pages/plan/updateEditPlanView", {
            error: error.response.data.errors[0].messages[0]
          });
        }
        throw error;
      }
    },
    handleChange(event) {
      this.$emit("change", event);
      if (!this.currentPlan || !this.applicationPlan) {
        return;
      }
      const dbName = this.currentPlan.name;
      const oldPlanName = this.applicationPlan.name;
      const newPlanName = event.plan.planName.trim();
      try {
        if (oldPlanName !== newPlanName) {
          this.$store.commit("pages/plan/updateProjectName", {
            name: newPlanName
          });
        }
        if (event.plan.willUpdateDatabase && dbName !== newPlanName) {
          this.updatePlan(newPlanName);
        }
      } catch (error) {
        this.$store.commit("pages/plan/updateProjectName", {
          name: oldPlanName
        });
      }
    },
    handleClickEditPlanViewOpen() {
      if (!this.partnerUser) return;
      this.$store.commit("pages/plan/updateEditPlanViewVisible", {
        isVisible: true
      });
    },
    handleClickEditPlanViewClose() {
      const isInvalidPlanName = this.planName.trim() === "";
      if (isInvalidPlanName) {
        return;
      }
      this.$store.commit("pages/plan/updateEditPlanViewVisible", {
        isVisible: false
      });
    },
    handleClickCreateEventViewOpen() {
      this.$store.commit("pages/plan/updateCreateEventView", {
        isVisible: true
      });
    },
    handleClickChangeTimeLineMagnification(timeLineMagnification) {
      this.$store.commit("pages/plan/updatePlanSettings", {
        planId: this.planId,
        timeLineMagnification
      });
    }
  },
  render(createElement) {
    return createElement(ProjectHeader, {
      props: {
        graduateYear: this.graduateYear,
        planName: this.planName,
        planPeriod: this.planPeriod
      },
      on: {
        change: this.handleChange,
        clickEditPlanViewOpen: this.handleClickEditPlanViewOpen,
        editPlanViewClose: this.handleClickEditPlanViewClose,
        clickCreateEventViewOpen: this.handleClickCreateEventViewOpen,
        clickChangeTimeLineMagnification: this
          .handleClickChangeTimeLineMagnification
      }
    });
  }
});
